import { gql } from '@apollo/client';

export const fetchTransactionAccountDetails = gql`
  query fetchTransactionAccountDetails($id: ID!) {
    transactionAccount(id: $id) {
      id
      partnerAccountId
      transactionAccountNumber
      billToParty {
        name
        addressLine1
        addressLine2
        city
        state
        country
        postcode
        taxId
        taxIds {
          id
          label
          taxExempt
          metadata {
            vatStatus
          }
        }
        taxLabels {
          region
          taxIdLabels {
            description
            displayName
            type
            metadata {
              type
              labels {
                default
                label
                vatStatus
              }
            }
          }
        }
        taxExempt
      }
      productSubscriptions {
        nodes {
          billingFrequency
          billingStatus
          entitlementNumber
          pricingPlanId
          pricingPlan {
            type
            billingFrequency
            id
            currency
            pricingPlanType
            status
            description
            tiers {
              unitAmount
              flatAmount
              floor
              ceiling
            }
          }
          transactionAccountNumber
          latestPeriodEndDate
          latestPeriodStartDate
          productName
          productId
          edition
          offeringId
          cloudSiteHostname
          billingGroupId
          provisioningStatus
          id
          billedUsers
          trial
          isSandbox
          isApp
          trialEndDate
        }
      }
      billToPartyPricingEligibilty
      availableShipToParties {
        nodes {
          id
          name
          addressLine1
          addressLine2
          city
          state
          country
          postcode
          taxId
          taxExempt
        }
      }
      billingAdmins {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          email
          atlassianAccountId
          fullName
          isEmailVerified
        }
      }
      displayName
      isPartner
      status
      availableInvoiceGroups {
        totalCount
        nodes {
          id
          shipToParty {
            id
            name
            addressLine1
            addressLine2
            city
            state
            country
            postcode
            taxId
          }
          defaultPaymentMethod {
            type
            paymentIssue
            ... on CreditCard {
              card {
                expirationMonth
                expirationYear
                last4Numbers
                brand
              }
            }
            ... on PaymentOnTerms {
              terms {
                invoiceDueDays
              }
            }
          }
          shipToPriceEligibility
        }
      }
      availablePaymentMethods {
        totalCount
        nodes {
          id
          type
          default
          paymentIssue
          ... on CreditCard {
            card {
              expirationMonth
              expirationYear
              last4Numbers
              brand
            }
          }
          ... on PaymentOnTerms {
            terms {
              invoiceDueDays
            }
          }
        }
      }
      updatePaymentMethodLink
      customerBalances {
        usd
        jpy
      }
    }
  }
`;
